import { createFileRoute } from '@tanstack/react-router';
import { AdminInvitationsView } from '@/components/admin/AdminInvitationsView';
import type { InvitationsPageParams } from '@/lib/queries/admin';

type Status = 'pending' | 'accepted' | 'revoked' | 'expired';

interface InvitationsSearch {
  readonly status?: Status;
  readonly cursor?: string;
}

const ALLOWED_STATUS: ReadonlyArray<Status> = [
  'pending',
  'accepted',
  'revoked',
  'expired',
];

export const Route = createFileRoute('/_authed/admin/invitations/')({
  validateSearch: (raw: Record<string, unknown>): InvitationsSearch => {
    const status =
      typeof raw.status === 'string' &&
      (ALLOWED_STATUS as ReadonlyArray<string>).includes(raw.status)
        ? (raw.status as Status)
        : undefined;
    const cursor =
      typeof raw.cursor === 'string' && raw.cursor.length > 0
        ? raw.cursor
        : undefined;
    return {
      ...(status !== undefined ? { status } : {}),
      ...(cursor !== undefined ? { cursor } : {}),
    };
  },
  component: AdminInvitationsPage,
});

function AdminInvitationsPage() {
  const search = Route.useSearch();
  const filter = search.status ?? 'pending';
  const listParams: InvitationsPageParams = {
    status: filter,
    pageSize: 50,
    ...(search.cursor ? { cursor: search.cursor } : {}),
  };

  return (
    <AdminInvitationsView
      listParams={listParams}
      filter={filter}
      cursor={search.cursor}
    />
  );
}
